import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useLink } from '../../hooks/useLink.js';
import { style } from '../../utils/style.js';
export const HorizontalNavigationLink = JSX(({ className = '', index, text, ...rest }) => {
    const link = useLink();
    const { href, target, onClick } = link(rest);
    return (_jsx("a", { className: style('text-secondary-text', className), href: href, target: target, onClick: onClick, children: text || `Документ ${index}` }));
});
//# sourceMappingURL=HorizontalNavigationLink.js.map